module.exports = __webpack_public_path__ + "img/a5ada07.png";